function canonical(value) {
    return value
        .normalize('NFC')
        .replace(/[‐-―−]/g, '-')
        .replace(/[‘’]/g, "'")
        .replace(/[“”]/g, '"')
        .replace(/\s+/g, ' ')
        .trim();
}
export function confirmationMatches(typed, expected) {
    return canonical(typed) === canonical(expected);
}
//# sourceMappingURL=confirm.js.map